module.exports = __webpack_public_path__ + "img/mark2_s.e1634a94.png";